import script from "./NewPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPost.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__